import { render, staticRenderFns } from "./pageTitleModule.vue?vue&type=template&id=0ec246ac"
import script from "./pageTitleModule.vue?vue&type=script&lang=js"
export * from "./pageTitleModule.vue?vue&type=script&lang=js"
import style0 from "./pageTitleModule.vue?vue&type=style&index=0&id=0ec246ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports